"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitActionConfig = void 0;
const splitActionConfig = (splitAction) => {
    const actions = Object.keys(splitAction)
        .filter(x => !['type', 'getState'].includes(x))
        .map(x => x)
        .map(x => [x, splitAction[x]]);
    return {
        getState: splitAction.getState,
        click: (data, targetOption, tableRef) => actions.forEach(([option, action]) => {
            if (targetOption !== option)
                return;
            action.click(data, undefined, tableRef);
        }),
        isLoading: (data, targetOption) => actions.some(([option, action]) => {
            if (targetOption !== option)
                return false;
            return action.isLoading && action.isLoading(data, undefined);
        }),
        notAllowed: actions.every(([_, action]) => action.notAllowed),
        disabled: (data, targetOption) => actions.some(([option, action]) => {
            if (targetOption !== option)
                return false;
            return action.disabled && action.disabled(data, undefined);
        }),
        hidden: (data, targetOption) => actions.some(([option, action]) => {
            if (targetOption !== option)
                return false;
            if (action.notAllowed)
                return true;
            return action.hidden && action.hidden(data, undefined);
        }),
    };
};
exports.splitActionConfig = splitActionConfig;
//# sourceMappingURL=splitAction.js.map